"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = capitalizeFirstLetter;
function capitalizeFirstLetter(value) {
  return value ? value.trim()[0].toUpperCase() + value.trim().slice(1) : null;
}